import i18next from "@/i18n";

import { getCollectionsAllUrl } from "@utils/archive-sale";

export const MENUS = [{ name: "Shop", url: getCollectionsAllUrl() }];

// 서브 카테고리 매핑을 위한 키 값
const CATEGORY = "category";
const ACCESSORIES = "Accessories";
const CLOTHING = "Clothing";
const FOOTWEAR = "Footwear";

// 카카오톡 리다이렉트 url
const KAKAO_REDIRECT_URL = "kakaoLoginRedirectUrl";

export { CATEGORY, ACCESSORIES, CLOTHING, FOOTWEAR, KAKAO_REDIRECT_URL };

/** 컬렉션 sort 메뉴 */
export const COLLECTION_SORT = [
  { name: i18next.t("collection.sort.newest"), value: "COLLECTION_DEFAULT" },
  { name: i18next.t("collection.sort.featured"), value: "BEST_SELLING" },
  {
    name: i18next.t("collection.sort.high_price"),
    value: "PRICE",
    reverse: true,
  },
  { name: i18next.t("collection.sort.low_price"), value: "PRICE" },
];

export const DAY = ["일", "월", "화", "수", "목", "금", "토"];

export const BRAND_FILTER = [
  "All",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "#",
];
